module.exports = __webpack_public_path__ + "img/img75.0ad68b38.svg";